var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.currentEvent && !_vm.eventEnded)?_c('div',[_c('Button',{staticClass:"event-button",on:{"click":_vm.shareModal}},[_c('img',{staticClass:"event-img",attrs:{"src":_vm.getImageUrl('event.png')}}),_c('label',{staticClass:"event-label"},[_vm._v(_vm._s(_vm.countDown))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }